import { useCallback, useEffect, useState } from 'react';
import { ENDPOINTS } from 'site-constants';

import { httpRequest } from '@candu-ai/commons/network';

interface UserTrait {
  name: string;
  traitType: 'String' | 'Boolean' | 'Number' | 'Date';
}

/** A growing set up user traits, fetches a good group but adding search strings grows the data set */
export const useUserTraits = () => {
  const [data, setData] = useState(new Map<string, UserTrait>());
  const [unfilteredData, setUnfilteredData] = useState<UserTrait[]>([]);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);

  const endpoint = `${ENDPOINTS.autoComplete}?finder=byUserTraits`;

  const fetchUserTraits = useCallback(async () => {
    try {
      const rawResponse = await httpRequest(endpoint);
      const parsed = (await rawResponse.json()) as UserTrait[];

      const newUnfilteredData = parsed.reduce((acc, trait) => {
        // remove duplicate entries that match both trait name and type
        const exists = acc.find(
          ({ name, traitType }) => name === trait.name && traitType === trait.traitType,
        );

        if (exists) {
          return acc;
        }

        return [...acc, trait];
      }, []);

      setUnfilteredData(newUnfilteredData);

      const newData = new Map(data);
      parsed.forEach((trait) => {
        newData.set(trait.name, trait);
      });
      setData(newData);

      setLoading(false);
    } catch (e) {
      setError(true);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUserTraits();
  }, []);

  return {
    loading,
    data: [...data.values()],
    unfilteredData,
    error,
  };
};
